// imports react
import axios from 'axios';
import React, { useEffect, useState } from 'react';

//imports libraries
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner';

import { urlAPI_Current } from '../../config';
import { Menu } from '../../components/Menu';
import styles from "../../styles/adminInvitationsManager.module.css";
import Swal from 'sweetalert2';
import { verifyAuthToken } from '../../verifyAuthToken';

export function AdminEnterprise() {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [enterprises, setEnterprises] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const navigateTo = useNavigate()

    const [darkMode, setDarkMode] = useState(() => 
        window.localStorage.getItem('darkMode') === 'true'
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseEmail = await axios.post(
                    `${urlAPI_Current}/getProfile`, {} , {
                        headers: {
                          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                        }
                     }
                );
    
                if (responseEmail.data.user.codTipoUsuario == 2) {
                    getEnterprises();
                } else {
                    toast.error("Você não tem acesso a essa página");
                    navigateTo("/login");
                }
            } catch (error) {
                console.error("Erro ao buscar perfil:", error);
            }
        };
    
        fetchData();
    
        window.localStorage.setItem('darkMode', darkMode);
        document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    }, [darkMode]);
    
    async function createEnterprise(){
        try {
            if(name == "" || description == ""){
                toast.error("Preencha todos os campos");
                return;
            } else {
                const response = await axios.post(
                    `${urlAPI_Current}/addEnterprise`,
                    {
                        enterpriseName: name,
                        enterpriseDescription: description
                    } , {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,  
                            'Content-Type': 'application/json'
                        }
                    }
                )
                if(response.data.success == true){
                    toast.success("Empresa criada com sucesso!");
                    getEnterprises();
                } else {
                    toast.error("Erro ao criar empresa");
                }
            }
        } catch(err){
            console.log(err);
            toast.error("Erro ao criar empresa");
        } finally {
            setName("");
            setDescription("");
        }
    }

    async function getEnterprises(){
        const response = await axios.post(
            `${urlAPI_Current}/getAllEnterprises`, {} , {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                }
             }
        )
        if(response.data.success == true){
            console.log(response.data.enterprises);
           setEnterprises(response.data.enterprises)
        } else {
            toast.error("Erro ao buscar empresas");
        }
    }

    async function deleteEnterprise(enterpriseId){
        const result = await Swal.fire({
            title: 'Deseja Continuar?',
            text: "Deseja realmente excluir essa empresa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            didOpen: () => {
                const popup = Swal.getPopup();
                if (popup) {
                    popup.style.backgroundColor = darkMode ? '#212121' : '#f0f0f0';
                    const popupText = popup.querySelector('.swal2-title');
                    if (popupText) {
                        popupText.style.color = darkMode ? '#f0f0f0' : '#212121';
                    }
        
                    const popupTextContent = popup.querySelector('.swal2-html-container');
                    if (popupTextContent) {
                        popupTextContent.style.color = darkMode ? '#f0f0f0' : '#212121';
                    }
                }
            }
        });
    
        if (result.isConfirmed) {
            try {
                const response = await axios.post(
                    `${urlAPI_Current}/deleteEnterprise`,
                    {
                        enterpriseId: enterpriseId
                    }, {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                        }
                    }
                );
            
                if(response.data.success){
                    toast.success('Empresa deletada com sucesso!');
                    getEnterprises();
                } else {
                    toast.error('Erro ao deletar empresa');
                }
            } catch (error) {
                console.log("Erro ao deletar empresa");
            }
        } 
    }

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    
    const filteredEnterprises = enterprises?.filter(
        (enterprise) =>
            enterprise?.nome?.toLowerCase().includes(searchTerm?.toLowerCase() || '')
    ) || [];
    

    useEffect(() => {
        verifyAuthToken(navigateTo);
    }, []);

    return (
        <div className={styles.divAdminBi}>
            <Menu darkMode={darkMode} adminUser={true} adminPageActually="enterprises"/>
            <div className={styles.containerBI}>
                <div className="content d-flex flex-column flex-column-fluid" id="kt_content"  data-bs-theme={darkMode ? "dark" : "light"}>
                    <div id="kt_content_container" style={{ width: "1800px", margin: "0 auto" }}>
                        <div className="card card-flush">
                            <div className="card-header mt-6">
                                <div className="card-title">
                                    <div className="d-flex align-items-center position-relative my-1 me-5">
                                        <i className="ki-outline ki-magnifier fs-3 position-absolute ms-5"></i>
                                        <input 
                                            type="text" 
                                            data-kt-permissions-table-filter="search" 
                                            className={`form-control form-control-solid w-250px ps-13 ${styles.inputFilter}`}
                                            placeholder="Procurar por nome" 
                                            defaultValue={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                </div>
                                <div className="card-toolbar">	
                                    <button type="button" className="btn btn-light-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_add_enterprise">
                                    <i className="ki-outline ki-plus-square fs-3"></i>Adicionar Empresa</button>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                    <thead>
                                        <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                            <th className="min-w-150px">Nome</th>
                                            <th className="min-w-200px">Descrição</th>
                                            <th className="text-end min-w-100px">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600">
                                        {filteredEnterprises.length > 0 ? (
                                            filteredEnterprises.map((enterprise, index) => (
                                                <tr key={index}>
                                                    <td>{enterprise.nome}</td>
                                                    <td>{enterprise.descricao}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-icon btn-active-light-primary w-30px h-30px" onClick={() => deleteEnterprise(enterprise.codEmpresa)}>
                                                            <i className={`ki-outline ki-trash fs-3 ${styles.botaoExcluir}`}></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center text-muted">
                                                    Nenhuma empresa encontrada.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal fade" id="kt_modal_add_enterprise" tabindex="-1" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered mw-650px">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h2 className="fw-bold">Adicionar Empresa</h2>
                                        <div className="btn btn-icon btn-sm btn-active-icon-primary" data-kt-permissions-modal-action="close">
                                            <i className="ki-outline ki-cross fs-1" data-bs-dismiss="modal"></i>
                                        </div>
                                    </div>
                                    <div className="modal-body mx-5 mx-xl-15 my-7">
                                        <form id="kt_modal_add_enterprise_form" className="form w-100" onSubmit={(e) => e.preventDefault()}>
                                            <div className="fv-row mb-7">
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Nome</span>
                                                </label>
                                                <input 
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite o nome"
                                                    type="text" 
                                                    name="name" 
                                                    value={name} 
                                                    onChange={(e) => setName(e.target.value)}
                                                    required 
                                                />
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Descrição</span>
                                                </label>
                                                <textarea
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite a descrição"
                                                    name="description"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    rows="3"
                                                    required
                                                ></textarea>
                                            </div>
                                            <div className="text-center pt-15">
                                                <button type="reset" className="btn btn-light me-3" data-kt-permissions-modal-action="cancel" data-bs-dismiss="modal">Cancelar</button>
                                                <button type="submit" className="btn btn-primary" data-kt-permissions-modal-action="submit">  
                                                    <span className="indicator-label" onClick={createEnterprise}>Criar</span> 
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
